module.exports = __webpack_public_path__ + "img/balance-icon.b088914a.svg";